module.exports = __webpack_public_path__ + "img/8.7cf4ba2d.png";